import React from 'react'
import errorimg from "../../assets/error/error.png"
import { NavLink, useNavigate } from "react-router-dom";

const Page404 = () => {
    const navigate = useNavigate()
    return (

        <div>



            <div className="bg-white py-6 sm:py-8 lg:py-1">
                <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
                    <div className="flex flex-col items-center">
                        <img src={errorimg} style={{ height: "400px" }} alt=" Logo" />
                        <h1 className="mb-2 text-center text-2xl font-extrabold text-gray-800 md:text-3xl">OOPS ! Page Not Found</h1>
                        <p className="mb-2 max-w-screen-md text-center text-gray-500 md:text-lg">The page you’re looking for doesn’t Exist.</p>
                        <a className="align-middle select-none bg-mblack font-mfont font-bold text-center
                     uppercase transition-all disabled:opacity-50 disabled:shadow-none 
                     disabled:pointer-events-none text-md py-3 px-10 rounded-lg border
                      border-mblack text-mwhite hover:opacity-75 focus:ring cursor-pointer
                      focus:ring-gray-300 active:opacity-[0.85] mt-1 mx-auto flex ">
                            <span onClick={() =>
                                navigate({
                                    pathname: `${process.env.PUBLIC_URL}/`
                                })
                            } >  Go Home</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Page404